import { css, styled } from '../../hooks/theme';

interface ContainerProps {
  visible?: boolean;
  width?: number | string;
  height?: number | string;
  hoverable?: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: ${props => props.width || '284px'};
  height: ${props => props.height || 'fit-content'};
  padding: 32px;

  background: #ffffff;
  border-radius: 8px;
  transition: box-shadow 0.2s;

  ${props =>
    props.hoverable &&
    css`
      &:hover {
        box-shadow: 0px 2px 12px 2px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.06);
      }
    `}
`;
